module.exports = __webpack_public_path__ + "images/sprites/ui/cv_btn_wide_cea90e5b3ed0ab95401869d333a38142.png";